/**
 *  @class
 *  @function ThemeFooter
 */

if (!customElements.get('theme-footer')) {
  class ThemeFooter extends HTMLElement {
    constructor() {
      super();
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.accordions = this.querySelectorAll('details');

      // Call onResize directly to set initial state based on window size
      this.onResize();

      this.accordions.forEach((accordion) => {
        accordion.addEventListener('toggle', () => {
          this.rotateArrow(accordion);
        });
      });
      
      // Add resize event listener
      window.addEventListener('resize', this.onResize);
    }

    

    rotateArrow(accordion) {
      const arrow = accordion.querySelector('summary span');
      if (!arrow) return;
      arrow.classList.toggle('rotated', accordion.open);
    }

    disconnectedCallback() {
      // Remove resize event listener when element is removed
      window.removeEventListener('resize', this.onResize);
    }

    onResize() {
      this.accordions.forEach((accordion) => {
        if (window.innerWidth > 768 || accordion.closest('.widget--menu-last')) {
          accordion.setAttribute('open', '');
        } else {
          accordion.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('theme-footer', ThemeFooter);
}
